import { Component, Input } from '@angular/core';
import { SchillerFilters } from '../ecg-fab-tools/layout-fab-tools/layout-fab-tools.component';
import { FilterType, IFilter } from '../models/ifilter';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'fixed-filters',
    templateUrl: './fixed-filters.component.html',
    styleUrls: ['./fixed-filters.component.css'],
    standalone: true,
    imports: [MatIcon, NgIf, TranslatePipe, MatTooltip],
})
export class FixedFiltersComponent {
    // Data Members

    @Input() schillerFilters!: SchillerFilters;
    @Input() manufacturer!: string;
    lowPass: IFilter | null = null;
    highPass: IFilter | null = null;
    notch: IFilter | null = null;

    private _filters: Array<IFilter> | null = null;

    get filters() {
        return this._filters;
    }

    @Input()
    set filters(filters) {
        if (filters !== null) this._filters = filters.filter((filter) => filter.type == FilterType.fixed);
        else this._filters = null;

        this.extractBaseFilters();
    }

    get showFidoliWarning(): boolean {
        if (!this.manufacturer) return false;
        if (this.manufacturer.toLowerCase().includes('schiller')) return false;
        return this.schillerFilters?.lowFilter > 0 || this.schillerFilters?.highFilter > 0;
    }

    // private functions

    extractBaseFilters() {
        this.lowPass =
            this.filters !== null
                ? (this.filters.find((filter) => filter.name.toLowerCase().indexOf('lowpass') >= 0) ?? null)
                : null;
        this.highPass =
            this.filters !== null
                ? (this.filters.find((filter) => filter.name.toLowerCase().indexOf('highpass') >= 0) ?? null)
                : null;
        this.notch =
            this.filters !== null
                ? (this.filters.find((filter) => filter.name.toLowerCase().indexOf('mains') >= 0) ?? null)
                : null;
    }
}
